// extracted by mini-css-extract-plugin
export var story__fourthSectionImage = "storyFourthSection-module--story__fourthSectionImage--ENsKK";